import { usePageTitle } from "context/PageTitleContext";
import useGetNotices from "hooks/useGetNotices";

import DashboardWidget from "components/Dashboard/DashboardWidget";
import DashboardWelcomeItem from "components/Dashboard/DashboardWelcomeItem";

import CoursesIcon from "assets/icons/courses.svg?react";
import AcademicOverviewIcon from "assets/icons/academicOverview.svg?react";
import quickLinksIcon from "assets/icons/quickLinks.svg?react";
import supportIcon from "assets/icons/support.svg?react";

import styles from "./Dashboard.module.css";

const Dashboard = () => {
    usePageTitle(
        "Parent Hub",
        "Welcome to USPA's Parent Hub. Use this tool to view your student's courses and academic progress. Additionally, you can manage your tuition, college admissions, and request transcripts.",
    );

    const { notices, isLoading: noticesLoading } = useGetNotices();

    return (
        <div className={styles.dashboardContainer}>
            <div className={styles.welcomeMessage}>
                <h1>Explore the Parent Hub</h1>
                <p>
                    Use the options below to navigate to different sections of
                    the USPA Parent Hub.
                </p>
                <DashboardWelcomeItem
                    title="My Students Courses"
                    description="View your students courses"
                    links={[{ text: "View Now", url: "/courses" }]}
                    icon={CoursesIcon}
                    isFullWidth={false}
                />
                <DashboardWelcomeItem
                    title="Academic Overview"
                    description="View progress and achievements"
                    links={[
                        {
                            text: "View Now",
                            url: "https://gouspa.maestrosis.com",
                            isExternal: true,
                        },
                    ]}
                    icon={AcademicOverviewIcon}
                    isFullWidth={false}
                />
                <DashboardWelcomeItem
                    title="Quick Links"
                    description="Quickly Access External Resources"
                    links={[
                        {
                            text: "Manage My Tuition",
                            url: "https://billing.stripe.com/p/login/eVqeVe9Vu24N3dX7DR5ZC00",
                            isExternal: true,
                        },
                        {
                            text: "College Admissions",
                            url: "https://app.scoir.com/signin",
                            isExternal: true,
                        },
                        {
                            text: "Transcripts",
                            url: "https://registration.parchment.com/member/3fc0f50e-0d1e-11ed-ab0b-9fc21804c964",
                            isExternal: true,
                        },
                    ]}
                    icon={quickLinksIcon}
                    isFullWidth
                />
                <DashboardWelcomeItem
                    title="Contact Support"
                    description="Need technical assistance? Reach out to our support team now"
                    links={[{ text: "Get Support", url: "/support" }]}
                    icon={supportIcon}
                    isFullWidth
                />
            </div>
            <DashboardWidget
                title="Notice Board"
                variant="noticeBoard"
                hasFilter
                data={notices}
                isLoading={noticesLoading}
            />
        </div>
    );
};

export default Dashboard;
